import { render, staticRenderFns } from "./KuesionerKkTidakValid.vue?vue&type=template&id=24d8a407&scoped=true"
import script from "./KuesionerKkTidakValid.vue?vue&type=script&lang=js"
export * from "./KuesionerKkTidakValid.vue?vue&type=script&lang=js"
import style0 from "./KuesionerKkTidakValid.vue?vue&type=style&index=0&id=24d8a407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d8a407",
  null
  
)

export default component.exports